import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  LOADER_TIMEOUT_TIME,
  ROLE,
  SWAL_SETTINGS,
  showFilterlist,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  handleServerValidations,
  removeSpecialCharacter,
  TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import * as WalletService from '../../../center/services/wallet.services';
import { useFormik } from "formik";
import { DatePicker, Drawer } from "rsuite";
import CustomError from "../../../../utils/customError";
import * as Yup from "yup";
import { list, deletePatient, changeStatus } from "../../../doctor/services/patient.services";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { GetAllCenters } from "../../services/usermgmt.services";
import CenterFilter from "../../common/centerFilter";
import PatientCenterFilter from "../../common/patientCenterFilter";

const PatientTables = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [List, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    // { title: t("sidebar_link_restaurant"), url: "" },
    { title: t("Patient Management"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [centers, setCenters] = useState([]);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        list(formData, ROLE.SUPER_ADMIN)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);
            //   console.log("data.data.data_ids", data.data.data_ids);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const viewfunction = (row) => {
    navigate(
      `/admin/patient-management/patient/view/${row._id}`
    );
  };

  const ChangeStatus = (data, Num) => {
    // let ids = Array.isArray(data) ? data : [data];
    const formData = new FormData();
    formData.append("o_id", data);
    // formData.append("o_id", JSON.stringify(ids));
    formData.append("status", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t("admin.cafes.msg_are_you_sure"),
      text: t("Do you really want to change the status."),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("admin.cafes.btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("admin.cafes.btn_yes"),
    }).then((result) => {
      // console.log("result", result);
      if (result.isConfirmed) {
        changeStatus(formData, ROLE.SUPER_ADMIN)
          .then((response) => {
            // console.log("kkkk---", response);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };



  function Deletefunction(data, email) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("admin.cafes.msg_are_you_sure"),
      text: t("admin.cafes.you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("admin.cafes.btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("admin.cafes.btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        // const formData = new FormData();
        // let ids = Array.isArray(data) ? data : [data];
        // formdata.append("o_id", row._id);
        // formData.append("o_id", data)
        // formData.append("email", email)
        deletePatient({ o_id: data }, ROLE.SUPER_ADMIN)
          .then((response) => {
            // console.log("🚀 ~ .then ~ response:", response);
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: "Patient deleted successfully",
                ...SWAL_SETTINGS,
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
    params.pgno = 1;
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
    $("#defaultcenter")[0].selectedIndex = 0;
    params.pgno = 1;
  };


  const goToEdit = (row) => {
    navigate(
      `/admin/patient-management/patient/${params.pgno}/edit/${row._id}`
    );
  };

  useEffect(() => {
    GetAllCenters()
      .then((data) => {
        setCenters(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);


  useEffect(() => {
    if (params.pgno && parseInt(params.pgno) !== 1) {
      navigate("/admin/patient-management/patient/list/1", { replace: true });
    }
  }, []);


  const headerMapping = {
    "patient_id": "Patient ID",
    "patient_name": "Patient Name",
    "email": "Email",
    "center_name": "Center Name",
    "address": "Address",
    "phone_number": "Phone Number",
    "reason": "Reason",
    "source_of_call": "Source Of Call",
    "other_source_of_call": "Source Of Call(Other)",
  };

  const handleExport = () => {
    const formData = new FormData()
    formData.append("page", 1)
    formData.append("per_page", datalength)
    formData.append("sort", JSON.stringify({}))
    formData.append("search", JSON.stringify({}))
    formData.append("global_search", globalsearch)
    list(formData,ROLE.SUPER_ADMIN).then(data => {
      setDataLength(data.data.total_records);
      const listData = data && data.data && data.data.list ? data.data.list : [];
      const printData = listData.map((item) => {
        const transformedItem = {};
        const patientRegisterID = item?.patient_register_id ? '#' + (item?.patient_register_id) : "-";
        const Name = capitalizeFirstLetter(item?.name) || 'N/A';
        const Email = item?.email || 'N/A';
        const centerName = item?.centers?.length ? capitalizeFirstLetter(item.centers[item?.centers?.length-1]?.center_name) : "N/A"
        const Address = capitalizeFirstLetter(item?.address) || "N/A"
        const phoneNumber = (item?.phone_number) || "N/A"
        const Reason = capitalizeFirstLetter(item?.reason) || "N/A"
        const sourceOfCall = capitalizeFirstLetter(item?.source_of_call) || "N/A"
        const OtherSourceOfCall = capitalizeFirstLetter(item?.other_source_of_call) || "N/A"

        for (const key in headerMapping) {
          if (headerMapping.hasOwnProperty(key)) {
            const newKey = headerMapping[key];
            switch (key) {
              case "patient_id":
                transformedItem[newKey] = (patientRegisterID);
                break;
              case "patient_name":
                transformedItem[newKey] = (Name);
                break;
              case "email":
                transformedItem[newKey] = (Email);
                break;
              case "center_name":
                transformedItem[newKey] = (centerName);
                break;
              case "address":
                transformedItem[newKey] = (Address);
                break;
              case "phone_number":
                transformedItem[newKey] = (phoneNumber);
                break;
              case "reason":
                transformedItem[newKey] = (Reason);
                break;
              case "source_of_call":
                transformedItem[newKey] = (sourceOfCall);
                break;
              case "other_source_of_call":
                transformedItem[newKey] = (OtherSourceOfCall);
                break;
              default:
                console.warn(`Unexpected key in headerMapping: ${key}`);
                transformedItem[newKey] = 'N/A';
                break;
            }
          }
        }
        return transformedItem;
      });
      const ws1 = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws1, 'Patient List');
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(blob, 'patient.xlsx');
      setTimeout(() => {
        setLoader(false);
      }, LOADER_TIMEOUT_TIME);
    }).catch(error => {
      setTimeout(() => {
        setLoader(false);
      }, LOADER_TIMEOUT_TIME);
      console.log("error ====> ", error);
    })
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("Patient Management")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlist}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <div className="me-3">
                  <PatientCenterFilter
                    data={centers}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("admin.filter_placeholder.btn_reset_filter")}
                </button>
                <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/patient-management/patient/add`)
                  }
                >
                  {t("admin.cafes.btn_add_new")}
                </button>
                <button className="btn btn-secondary mr-2" onClick={handleExport} disabled={datalength === 0}>Export Report</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Patient ID")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="patient_register_id"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Patient Name")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="name"
                        />
                      </div>
                    </th>
                    <th>Email</th>
                    <th>Center</th>
                    <th>Address</th>
                    <th className="">{t("admin.cafes.list_heading_phone_number")}</th>
                    <th>Reason</th>
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("admin.list_heading.list_heading_created_date")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          defaultSorting={defaultSorting}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    <th className="status_head">{t("admin.list_heading.list_heading_status")}</th>
                    <th className="action_head">{t("admin.list_heading.list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={14}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {List.length ? (
                        List.map((row, i) => {
                          return (
                              <tr key={i}>
                                  <td>{row?.patient_register_id ? "#" + row?.patient_register_id : null}</td>
                                  <td>{row?.name ? <div className="d-flex">{row?.name ? capitalizeFirstLetter(TrimText(row.name, 30)) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                                  <td>{row?.email ? row.email : "N/A"}</td>
                                  {/* <td>{row?.center[0]?.center_name ? capitalizeFirstLetter(row.center[0]?.center_name) : "N/A"}</td> */}
                                  <td>{row?.centers?.map((center) => capitalizeFirstLetter(center?.center_name)).join(", ")}</td>
                                  <td>{capitalizeFirstLetter(TrimText(row?.address, 30))}</td>
                                  <td>{row?.phone_number ? row.phone_number : "N/A"}</td>
                                  <td>{row?.reason ? capitalizeFirstLetter(TrimText(row?.reason, 30)) : "N/A"}</td>
                                  <td>{row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                                  <td>
                                      {row.status === 1 ? (
                                          <button
                                              className="btn ripple btn-main-primary signbtn"
                                              onClick={() => {
                                                  ChangeStatus(row?._id, 0);
                                              }}
                                          >
                                              {t("Unblock")}
                                          </button>
                                      ) : (
                                          <button
                                              className="btn ripple btn-secondary"
                                              onClick={() => {
                                                  ChangeStatus(row?._id, 1);
                                              }}
                                          >
                                              {t("Block")}
                                          </button>
                                      )}
                                  </td>

                                  <td>
                                      <div className="d-flex">
                                          <button
                                              className="btn ripple btn-main-primary signbtn"
                                              onClick={() => {
                                                  viewfunction(row);
                                              }}
                                          >
                                              {t("admin.button.btn_view")}
                                          </button>

                                          <button
                                              className="btn ripple btn-success mlAction"
                                              onClick={() => {
                                                  goToEdit(row);
                                              }}
                                          >
                                              {t("admin.button.btn_edit")}
                                          </button>
                                          <button
                                              className="btn ripple btn-danger mlAction"
                                              onClick={() => {
                                                  Deletefunction(row?._id, row?.email);
                                              }}
                                          >
                                              {t("admin.button.btn_delete")}
                                          </button>
                                      </div>
                                  </td>
                              </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("admin.message.msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Patient Management",
                    path: "/admin/patient-management/patient/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientTables;
